<template>
  <div>
    <template v-if="showComponent.length > 0">
      <template v-if="showComponent.includes('ketshop')">
        <v-container>
          <ketshop-setting></ketshop-setting>
        </v-container>
      </template>
    </template>
    <template v-else>
      <div class="text-xs-center my-4">No integration available</div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import KetshopSetting from './KetshopSetting'
export default {
  components: {
    KetshopSetting
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    showComponent() {
      let menus = []
      if (['tcp'].includes(this.selectedBot.theme)) {
        menus.push('ketshop')
      }
      return menus
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/Plugin.vue